import React, { Component } from 'react';
import './style/Tip.css';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

class Tip extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, 'state', {
      compact: true,
      text: '',
      emoji: '',
    });
  }

  // for TipContainer
  componentDidUpdate(nextProps, nextState) {
    const { onUpdate } = this.props;

    if (onUpdate && this.state.compact !== nextState.compact) {
      onUpdate();
    }
  }

  render() {
    const { onConfirm, onOpen, onCancel, disabled } = this.props;
    const { compact, text, emoji } = this.state;
    return /*#__PURE__*/ React.createElement(
      'div',
      {
        className: 'Tip',
      },
      compact
        ? /*#__PURE__*/ React.createElement(
            'div',
            {
              className: disabled ? 'Tip__compact--disabled' : 'Tip__compact',
              onClick: disabled
                ? () => {}
                : () => {
                    onOpen();
                    this.setState({
                      compact: false,
                    });
                  },
            },
            disabled ? 'Adding highlights Disabled' : 'Add highlight'
          )
        : /*#__PURE__*/ React.createElement(
            'form',
            {
              className: 'Tip__card',
              onSubmit: event => {
                event.preventDefault();
                if (!this.state.text) return;
                onConfirm({
                  text,
                  emoji,
                });
              },
            },
            /*#__PURE__*/ React.createElement(
              'div',
              null,
              /*#__PURE__*/ React.createElement('h6', { className: 'Tip__header' }, 'Add highlight'),
              /*#__PURE__*/ React.createElement('textarea', {
                width: '100%',
                placeholder: 'Reply',
                autoFocus: true,
                value: text,
                onChange: event =>
                  this.setState({
                    text: event.target.value,
                  }),
                ref: node => {
                  if (node) {
                    node.focus();
                  }
                },
              })
            ),
            /*#__PURE__*/ React.createElement(
              'div',
              {
                className: 'Tip__buttons',
              },
              /*#__PURE__*/ React.createElement('input', {
                className: `Tip__submit ${!this.state.text && 'Tip__submit--disabled'}`,
                type: 'submit',
                value: 'Comment',
              }),
              /*#__PURE__*/ React.createElement(
                'button',
                {
                  className: 'Tip__cancel',
                  onClick: () => {
                    onCancel();
                  },
                },
                'Cancel'
              )
            )
          )
    );
  }
}

export default Tip;
